export const types = {
    SENDMESSAGE: 'SEND-MESSAGE',
    SENDCARD: 'SEND-CARD'
};
